import { compose, map, pluck, propOr } from 'ramda';
import { Icon, PageTitle } from '@fasstech/middle-design-system';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const ElectronicSignatureStarted = ({ getMiddleText, middleFeatures }) => {
  const SIGNATURE_STARTED_EMAIL_CONTENT_LIST = compose(
    pluck('CONTENT'),
    propOr([], 'SIGNATURE_STARTED_EMAIL_CONTENT_LIST')
  )(middleFeatures);

  return (
    <PageLayout>
      <Icon name={'circleSign'} size={70} />
      <PageTitle>{getMiddleText('SIGNATURE_STARTED_TITLE')}</PageTitle>

      <div className={'mt-8'}>
        <p>{getMiddleText('SIGNATURE_STARTED_TEXT')}</p>

        <ul className="font-bold flex flex-col gap-y-2 list-disc pl-6">
          {map((content) => {
            return <li key={content}>{content}</li>;
          }, SIGNATURE_STARTED_EMAIL_CONTENT_LIST)}
        </ul>
      </div>
    </PageLayout>
  );
};

export default ElectronicSignatureStarted;
